export const en = {
  nav: { home: "Home", pricing: "Pricing", demo: "Demo", signin: "Sign in with LinkedIn", signout: "Sign out" },
  hero: { title: "Boost LinkedIn reach with private, invisible pods", subtitle: "We match you to existing invite-only pods behind the scenes. No automation. Fair rotation, daily limits, and points for quality engagement." },
  cta: { pricing: "See Pricing", demo: "View Demo" },
  features: {
    invite: { title: "Invite-only quality", desc: "Invisible matching to curated pods." },
    fair: { title: "Fair & compliant", desc: "Manual click-through. No bots, ever." },
    points: { title: "Points & limits", desc: "2 submissions/day. Like=1, Comment=3." }
  },
  how: { title: "How it works", step1: "1. Request access and onboard.", step2: "2. We assign you to existing pods automatically.", step3: "3. Share, engage manually, earn points, grow reach." },
  compliance: { title: "Compliance", copy: "We never automate likes or comments. Users always click through to LinkedIn. Matching and rotation are server-side within the TOS." },
  faq: {
    title: "FAQ",
    platforms_q: "Which platforms?",
    platforms_a: "LinkedIn only for v1.",
    submissions_q: "How many submissions?",
    submissions_a: "Up to 2 active submissions per day.",
    points_q: "How are points calculated?",
    points_a: "Like = 1 point, Comment = 3 points. A minimum is required to submit."
  },
  pricing: {
    title: "Simple pricing",
    subtitle: "Choose a plan and request access. Cancel anytime.",
    starter: "Starter",
    pro: "Pro",
    team: "Team",
    price_starter: "$19/mo",
    price_pro: "$49/mo",
    price_team: "Contact",
    feat_curated: "Curated pods",
    feat_priority: "Priority matching",
    feat_analytics_basic: "Basic analytics",
    feat_analytics_adv: "Advanced analytics",
    feat_seats: "Multiple seats",
    feat_limits: "Custom limits",
    feat_sla: "SLA support",
    cta: "Request access"
  },
  demo: {
    title: "Demo (read-only)",
    subtitle: "Illustration of the manual engagement flow and points system.",
    queue_title: "Engagement Queue",
    points_title: "Points preview",
    open: "Open"
  },
  footer: { copy: "© EngagePods. v1 LinkedIn only. Invite-only pods." }
} as const;
